import MojitoPresentation from 'mojito/presentation';
import Search from 'applications/sports/components/search/index.js';

const { Button, FlexPane, Image, Overlay } = MojitoPresentation.Components;

const SearchOverlay = props => {
    const { isOpen, mojitoTools, onSearchClose } = props;
    const { config } = mojitoTools;
    return isOpen ? (
        <Overlay config={config.overlay}>
            <FlexPane config={config.searchHeader} class="ta-SearchOverlayHeader">
                <Button
                    config={config.backButtonContainer}
                    onClick={onSearchClose}
                    class="ta-backButton"
                >
                    <Image config={config.searchBackButtonIcon} />
                </Button>
                <Search
                    initiallyActive={isOpen}
                    onSearchClose={onSearchClose}
                    config={config.searchView}
                />
            </FlexPane>
        </Overlay>
    ) : null;
};

export default SearchOverlay;
